import MedicalRecordScene from './MedicalRecordScene';
export default MedicalRecordScene;